import { queryClient } from '@/tanstack-query.ts';
import { ExternalQueryOptions } from '@/modules/core/query-options/external.query-options.ts';
import { OptionsUtil } from '@/modules/common/utils/options.util.ts';

export class OptionsHelper {
  static banksCBRF = OptionsUtil.createSourcedOptionsLoader(
    (signal) => queryClient.ensureQueryData(ExternalQueryOptions.getBanksCBRF(signal)),
    (item) => item.name,
    { getCode: (item) => item.identificationCode }
  );
}
